import {RouterProvider} from 'react-router-dom'
import {StyleSheetManager, ThemeProvider} from 'styled-components'
import {getAppTheme, GlobalStyles} from '@/theme/theme.ts'
import {router} from './router.tsx'
import {Toaster} from 'react-hot-toast'
import {ToastBar} from '@components/ui/toast-bar/ToastBar.tsx'
import {userMe} from '@/features/auth/store/actions.ts'
import {useEffect} from 'react'
import {useAuthStore} from '@/features/auth/store/store.ts'
import dayjs from '@/dayjs.ts'

export default function App() {
    const themeName = 'light' //get it from the app reducer

    const accessToken = useAuthStore(state => state.accessToken)
    useEffect(() => {
        if (accessToken) {
            void userMe()
        }
    }, [userMe, accessToken])
    dayjs.locale('it')
    return (
        <ThemeProvider theme={getAppTheme({name: themeName})}>
            <StyleSheetManager>
                <>
                    <Toaster position="top-right">{toast => <ToastBar t={toast} />}</Toaster>
                    <GlobalStyles />
                    <RouterProvider router={router} />
                </>
            </StyleSheetManager>
        </ThemeProvider>
    )
}
